<template>
  <div class="mini-ecg" :class="theme">
    <!-- <svg ref="svg" width="100" height="30"></svg> -->
    <canvas ref="canvas"@mouseleave="cursorData=null" @mousemove="updateCursor"></canvas>
    <div class="cursor" v-if="showTooltip && cursorData" :style="{left: cursorData.x+'px'}">
      <div class="line"></div>
      <div class="dot" :style="{left: '-1px', top: (cursorData.y-1)+'px'}"></div>
    </div>
    <div class="tooltip" v-if="showTooltip && cursorData">t: <b>{{cursorData.label}}{{units.x}}</b>  v: <b>{{cursorData.value}}{{units.y}}</b></div>
  </div>
</template>

<script>
import d3 from '@/utils/d3importer'
import {padLinear} from '@/utils'
import widgetContent from '@/mixins/widgetContent'

let themes= {
  'blue': {
    strokeStyle: '#929EAD',
    fill: true,
    fillStyle: '#e2e3e8'
  }
}

export default {
  mounted(){
    // this.drawChart()
  },
  
  mixins: [widgetContent],
  props: ['data', 'theme', 'showTooltip', 'units'],
  // data(){
  //   return {
  //     fakeData: [{t:0,value:1},{t:0.1,value:2},{t:0.3,value:3},{t:0.4,value:2}]
  //   }
  // },
  data(){
    return {
      cursorData: null,
      x: null,
      y: null
    }
  },
  computed: {
    currentTheme () {
      return this.theme && themes[this.theme] ? themes[this.theme] : {}
    }
  },
  methods:{
    xGetter (d) {
      return d.t || d[0]
    },
    yGetter (d) {
      return d.value || d[1]
    },
    drawChart(){
      let x = d3.scaleLinear().domain(d3.extent(this.data,(d)=>this.xGetter(d))).range([0,this.size.width])
      let y = d3.scaleLinear().domain(padLinear(d3.extent(this.data,(d)=>this.yGetter(d)),0.1)).range([this.size.height,0])
      // d3.select(this.$refs.svg).append('rect').attr('width',100).attr('height',30).attr('fill','#590')
      this.$refs.canvas.setAttribute('width',this.size.width)
      this.$refs.canvas.setAttribute('height',this.size.height)
      let ctx = this.$refs.canvas.getContext('2d')
      let line = d3.line().x((d)=>x(this.xGetter(d))).y((d)=>y(this.yGetter(d))).context(ctx);
      let area = d3.area().x((d)=>x(this.xGetter(d))).y0(this.size.height).y1((d)=>y(this.yGetter(d))).context(ctx);
      ctx.beginPath();
      line(this.data);
      ctx.lineWidth = 1;
      ctx.strokeStyle = (this.currentTheme.strokeStyle) || "#d44";
      ctx.stroke();
      if(this.currentTheme.fill) {
        ctx.beginPath();
        area(this.data)
        ctx.fillStyle = (this.currentTheme.fillStyle) || "#e2e3e8";
        ctx.fill();
      }
      this.x = x
      this.y = y
    },
    updateCursor(e){
      if(!this.showTooltip) return
      let x = e.clientX - this.$refs.canvas.getBoundingClientRect().left
      let datum = this.data.find((d)=>this.x(this.xGetter(d))>x)
      this.cursorData = {
        x: x,
        y: this.y(this.yGetter(datum)),
        label: this.xGetter(datum) ? this.xGetter(datum).toFixed(2) : '',
        value: this.yGetter(datum) ? this.yGetter(datum).toFixed(2) : ''
      }
    }
  },
  watch: {
    size () {
      this.drawChart()
    }
  }
}
</script>

<style lang="stylus" scoped>
.mini-ecg
  position absolute
  width 100%
  height 100%
  cursor none
  .cursor
    position absolute
    top 0px
    height 100%
    pointer-events none
    .line
      width 1px
      height 100%
      background #ccc
      position absolute
      top 0px
    .dot
      width 2px
      height 2px
      border-radius 2px
      background #fff
      position absolute
  .tooltip
    position absolute
    // top 8px
    // left 8px
    top 120%
    left 0
    padding 3px
    m-font-size(12px)
    background #fff
    border solid 1px #ddd
    white-space nowrap
    box-shadow 0 0 5px rgba(0,0,0,0.2)
</style>